var moduleMap = {
	"./index.js": () => {
		return Promise.all([__webpack_require__.e("vendors-node_modules_prop-types_index_js-node_modules_react-icons_fa_index_esm_js-node_module-ab8302"), __webpack_require__.e("vendors-node_modules_react-router-dom_dist_index_js-node_modules_url_url_js"), __webpack_require__.e("vendors-node_modules_aws-sdk_client-cognito-identity-provider_dist-es_CognitoIdentityProvider-24e142"), __webpack_require__.e("webpack_sharing_consume_default_react_react"), __webpack_require__.e("webpack_sharing_consume_default_react-dom_react-dom"), __webpack_require__.e("webpack_sharing_consume_default_react-query_react-query"), __webpack_require__.e("src_bootstrap_js-webpack_sharing_consume_default_react_react")]).then(() => (() => ((__webpack_require__(2204)))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	var name = "default"
	var oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});